export const UxCircleLineIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="25"
      height="25"
      viewBox="0 0 25 25"
      fill="none"
    >
      <g id="majesticons:ux-circle-line">
        <g id="Group">
          <path
            id="Vector"
            d="M7.5 10.708V12.708C7.5 13.375 7.9 14.708 9.5 14.708C11.1 14.708 11.5 13.375 11.5 12.708V10.708M14.5 10.708L16 12.708M16 12.708L17.5 14.708M16 12.708L17.5 10.708M16 12.708L14.5 14.708"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            id="Vector_2"
            d="M12.5 22.708C18.0228 22.708 22.5 18.2309 22.5 12.708C22.5 7.18516 18.0228 2.70801 12.5 2.70801C6.97715 2.70801 2.5 7.18516 2.5 12.708C2.5 18.2309 6.97715 22.708 12.5 22.708Z"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
      </g>
    </svg>
  );
};
